import type { ReactNode } from "react";

/**
 * A tidy collapsible unit — the studio sidebar sections and the FPV rail both
 * build from this. Extracted from SourceControls when the FPV rail grew
 * sections of its own.
 */
export function Section({
  title, summary, open, onToggle, children, className,
}: {
  title: string;
  summary?: string;
  open: boolean;
  onToggle: () => void;
  children: ReactNode;
  className?: string;
}) {
  return (
    <div className={"sect" + (open ? " open" : "") + (className ? " " + className : "")}>
      <button className="sect-head" onClick={onToggle}>
        <span className="sect-chev">{open ? "▾" : "▸"}</span>
        <span className="sect-title">{title}</span>
        {summary && <span className="sect-summary">{summary}</span>}
      </button>
      {open && <div className="sect-body">{children}</div>}
    </div>
  );
}
